import { render, staticRenderFns } from "./NewNote.vue?vue&type=template&id=3d829894&scoped=true&"
import script from "./NewNote.vue?vue&type=script&lang=js&"
export * from "./NewNote.vue?vue&type=script&lang=js&"
import style0 from "./NewNote.vue?vue&type=style&index=0&id=3d829894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d829894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d829894')) {
      api.createRecord('3d829894', component.options)
    } else {
      api.reload('3d829894', component.options)
    }
    module.hot.accept("./NewNote.vue?vue&type=template&id=3d829894&scoped=true&", function () {
      api.rerender('3d829894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_Note/NewNote.vue"
export default component.exports